import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const requestServiceApi = createApi({
  reducerPath: "requestServiceApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "services/service-requests",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  // Removed tagTypes to fix the error

  endpoints: (builder) => ({
    createRequest: builder.mutation({
      query: (payload) => {
        // const payload = {

        // };

        // if (descriptionContent) {
        //   payload.descriptionContent = descriptionContent;
        // }

        // if (descriptionImage) {
        //   payload.descriptionImage = descriptionImage;
        // }

        return {
          url: "",
          method: "POST",
          body: payload,
        };
      },
    }),

    getRequest: builder.query({
      query: ({id}) => {
        let url;
        if (id) {
          url = `/${id}?`;
        }

        // const payload = {

        // };

        // if (descriptionContent) {
        //   payload.descriptionContent = descriptionContent;
        // }

        // if (descriptionImage) {
        //   payload.descriptionImage = descriptionImage;
        // }

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    cancelRequest: builder.mutation({
      query: ({ id }) => {
        // const payload = {

        // };

        // if (descriptionContent) {
        //   payload.descriptionContent = descriptionContent;
        // }

        // if (descriptionImage) {
        //   payload.descriptionImage = descriptionImage;
        // }

        return {
          url: `${id}/cancel`,
          method: "PATCH",
        };
      },
    }),
  }),
});

export const {
  useCreateRequestMutation,
  useGetRequestQuery,
  useCancelRequestMutation,
} = requestServiceApi;
